import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, DialogActions, Typography, useTheme } from "@mui/material";
import { CardQuantityControl } from "../ItemCard/CardQuantityControl";
import { ItemChip } from "../ItemCard/ItemChip";
import { SymbolFlags } from "../ItemCard/SymbolFlags";
import { DetailTabHeading } from "./DetailTabHeading";
import { DialogTabs } from "./ItemDetail-types";
/**
 * ItemDetailGeneral - Tab Displayed for Recipes and Products. Shows description of item and additional information depending on context.
 * @param {*} { props: ItemDetailGeneral }
 * @returns {*}
 */
export function ItemDetailGeneral(props) {
    const { itemName, itemDescription, itemChips, cardControlProps, cardControl, symbolFlags, setDialogContentMode } = props;
    // Modify openCustomizeModal to switch to the customize tab 
    // since ItemDetailDialog is already open when this component renders.
    const updatedCardControlProps = Object.assign(Object.assign({}, cardControlProps), { openCustomizeModal: (cardControlProps === null || cardControlProps === void 0 ? void 0 : cardControlProps.openCustomizeModal)
            ? () => setDialogContentMode(DialogTabs.CUSTOMIZE)
            : undefined });
    const theme = useTheme();
    return (_jsxs(_Fragment, { children: [_jsx(DetailTabHeading, { itemName: itemName }), itemDescription && (_jsx(Typography, { variant: "body1", dangerouslySetInnerHTML: { __html: itemDescription } })), _jsx(Box, Object.assign({ style: {
                    marginTop: theme.spacing(2),
                    marginBottom: theme.spacing(2),
                } }, { children: _jsx(SymbolFlags, { symbolFlags: symbolFlags, maxSymbols: 20 }) })), itemChips && itemChips.length > 0 && (_jsx(Box, Object.assign({ style: {
                    marginTop: theme.spacing(2),
                    marginBottom: theme.spacing(2),
                } }, { children: itemChips.map((recipeType) => (_jsx(ItemChip, { label: recipeType }, recipeType))) }))), _jsx(DialogActions, Object.assign({ sx: { position: "relative", justifyContent: "center", alignItems: "center" } }, { children: cardControl ? cardControl : updatedCardControlProps && _jsx(CardQuantityControl, Object.assign({}, updatedCardControlProps)) }))] }));
}
